import { render, staticRenderFns } from "./MessengerView.vue?vue&type=template&id=1e0f7d6b&scoped=true&"
import script from "./MessengerView.vue?vue&type=script&lang=js&"
export * from "./MessengerView.vue?vue&type=script&lang=js&"
import style0 from "./MessengerView.vue?vue&type=style&index=0&id=1e0f7d6b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e0f7d6b",
  null
  
)

export default component.exports